export default __webpack_public_path__ + "static/media/Dylan_Zeigler_Resume.72787e13.pdf";